import { HIGHLIGHT_DOMAIN, HIGHLIGHT_KEY } from '../../constants'

function getHighlightByIdSelector (id) {
  return (state) => {
    return state[HIGHLIGHT_DOMAIN][HIGHLIGHT_KEY.DATA][id]
  }
}

export default getHighlightByIdSelector
